import { render, staticRenderFns } from "./ot-claim-override-details.vue?vue&type=template&id=725855e0&scoped=true&"
import script from "./ot-claim-override-details.vue?vue&type=script&lang=ts&"
export * from "./ot-claim-override-details.vue?vue&type=script&lang=ts&"
import style0 from "./ot-claim-override-details.vue?vue&type=style&index=0&id=725855e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725855e0",
  null
  
)

export default component.exports